export enum ErrorType {
  PROJECT_WITH_EXTERNAL_ID_NOT_FOUND = 'project-with-external-id-not-found',
}
